import * as React from 'react';
import { ComponentProps, WidgetProps } from '@intermix-dashboard/core';
import { useThemeObserver } from '../hooks/useThemeObserver';
const Pie = React.lazy(() =>
  import('react-chartjs-2').then((module) => ({ default: module.Pie }))
);

export const IntermixPieChartComponentV1: React.FC<ComponentProps> = ({
  data,
}) => {
  const { display } = useThemeObserver();
  return (
    <React.Suspense fallback="loading...">
      {display && <Pie data={data.rows} />}
    </React.Suspense>
  );
};

export const IntermixPieChartWidgetV1: WidgetProps = {
  id: 'analytics-widget',
  name: 'Analytics Widget',
  component: IntermixPieChartComponentV1,
  options: { w: 3, h: 3 },
};
